import dateFormat from 'dateformat';

export const getDateFormatYear = (date) => {
  return dateFormat(date, 'yyyy-mm-dd');
};

export const getDateFormat = (date) => {
  return dateFormat(date, 'dd-mm-yyyy');
};

export const getDateFormatWithTime = (date) => {
  return dateFormat(date, 'dd-mm-yyyy HH:MM:ss');
};

export const getDefaultStartDate = () => {
  const date = new Date();
  const firstDay = new Date(date);
  firstDay.setFullYear(date.getFullYear() - 1);
  return dateFormat(firstDay, 'yyyy-mm-dd');
};

export const getDefaultFinishDate = () => {
  const date = new Date();
  const finishDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return dateFormat(finishDay, 'yyyy-mm-dd')
};

export const getDefaultStartDateFromNewYear = () => {
  let date = new Date();
  let currentMonth = date.getMonth();// 0 = январь, 11 = декабрь

  let firstDay, lastDay;
  if (currentMonth === 0) { 
    firstDay = new Date(date.getFullYear() - 1, 9, 1); 
    lastDay = new Date(date.getFullYear(), currentMonth + 1, 0);
  } else {
    firstDay = new Date(date.getFullYear(), 0, 1);
    lastDay = new Date(date.getFullYear(), currentMonth + 1, 0);
  }
  return { 
    firstDay: dateFormat(firstDay, 'yyyy-mm-dd'),
    lastDay: dateFormat(lastDay, 'yyyy-mm-dd')
  };
};
